import {CopyToClipboardButton} from '@github-ui/copy-to-clipboard'
import type {PortalTooltipProps} from '@github-ui/portal-tooltip/portalled'

import {shortSha} from '../utils/short-sha'

export function CopySHA({sha, direction = 's'}: {sha: string; direction?: PortalTooltipProps['direction']}) {
  return (
    <CopyToClipboardButton
      textToCopy={sha}
      ariaLabel={`Copy full SHA for ${shortSha(sha)}`}
      tooltipProps={{direction, anchorSide: 'outside-bottom'}}
      size="small"
      avoidStyledComponent={true}
      hasPortalTooltip={true}
    />
  )
}

try{ CopySHA.displayName ||= 'CopySHA' } catch {}